var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"section-change"},[_c('div',{staticClass:"col-8 col-lg-8 col-xl-5 mx-auto py-xl-2"},[_c('form-order',{attrs:{"title":_vm.$gettext('Change Table/Room/Cover'),"isChangeOrder":true}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }